
import moment from 'moment'
import objectPath from 'object-path'

moment.locale('ru')

const getters = {
  isLoading: state => state.isLoading,
  getDocumentsFormLoading: state => state.documentsFormLoading,
  getChat: state => state.chat,
  isChatDefaultOpened: state => !Object.keys(state.bookings).length,
  getServiceField: state => target => objectPath.get(state, target),
  getBookingsServices: state => state.bookings,
  getAllBookingsPenalties: state => state.allBookingsPenalties,
  getDocuments: state => state.documents,
  getTourists: state => state.tourists,
  getFeedback: state => state.feedback,
  isLoadingError: state => state.isLoadingError,
  getTouristsForSearch: (state, rootState) => state.tourists.map((tourist, index) => ({
    id: tourist.id,
    name: tourist.name,
    surname: tourist.surname,
    middleName: tourist.middleName,
    gender: tourist.gender,
    birthday: moment.unix(tourist.birthday).format('DD.MM.YYYY'),
    documentNumber: tourist.document.number,
    roomId: null,
    phone: tourist.phone,
    email: tourist.email,
    documentType: tourist.document.type,
    expirationDate: moment.unix(tourist.document.expirationDate).format('DD.MM.YYYY'),
    citizen: tourist.citizen,
    variantId: rootState.cart.visa.visas.selected[index],
    visaId: rootState.cart.visa.visas.ids[index]
  })),
  getInclude: state => state.include,
  getNumberOfTourists: (state) => {
    const tourists = state.tourists

    return {
      total: tourists.length,
      adults: tourists.filter(tourist => moment().diff(moment.unix(tourist.birthday), 'years') >= 12).length,
      children: tourists.filter(tourist => moment().diff(moment.unix(tourist.birthday), 'years') < 12).length,
      numbrOfChildren: tourists.filter((tourist) => {
        const age = moment().diff(moment.unix(tourist.birthday), 'years')

        return age >= 2 && age < 12
      }).length,
      numberOfInfants: tourists.filter(tourist => moment().diff(moment.unix(tourist.birthday), 'years') < 2).length,
      ages: tourists
        .filter(tourist => moment().diff(moment.unix(tourist.birthday), 'years') < 12)
        .map(tourist => moment().diff(moment.unix(tourist.birthday), 'years'))
    }
  },
  getOrderInfo: (state) => {
    const today = moment(moment().format('DD.MM.YYYY'), 'DD.MM.YYYY').unix()

    return {
      id: state.id,
      paymentHash: state.paymentHash,
      orderCurrency: state.orderCurrency,
      status: state.status,
      manager: state.manager,
      price: state.price,
      country: state.country,
      createDate: moment.unix(state.dates.create).format('DD.MM.YYYY'),
      startDate: moment.unix(state.dates.start).format('DD.MM.YYYY'),
      endDate: moment.unix(state.dates.end).format('DD.MM.YYYY'),
      paymentDate: moment.unix(state.dates.payment).format('DD.MM.YYYY'),
      overduePaymentDate: today >= state.dates.payment,
      prepaymentDate: moment.unix(state.dates.prepayment).format('DD.MM.YYYY'),
      overduePrepaymentDate: today >= state.dates.prepayment,
      durationInDays: moment.duration(
        moment(moment.unix(state.dates.end).format('YYYY-MM-DD'), 'YYYY-MM-DD')
          .diff(moment(moment.unix(state.dates.start).format('YYYY-MM-DD'), 'YYYY-MM-DD'), 'days'),
        'days'
      ).asDays()
    }
  },
  getOrderPrice: (state) => {
    const bookings = state.bookings
    const bookingsServicesList = Object.keys(bookings)

    const {
      amount,
      markup
    } = bookingsServicesList.reduce((sum, service) => ({
      amount: sum.amount + bookings[service].reduce((sumService, serviceItem) => (
        sumService + serviceItem.price.amount
      ), 0),
      markup: sum.markup + bookings[service].reduce((sumService, serviceItem) => (
        sumService + serviceItem.price.markup
      ), 0),
    }), { amount: 0, markup: 0 })

    return {
      amount,
      amountAgency: amount - markup,
      markup,
      currency: bookings[bookingsServicesList[0]]
        ? bookings[bookingsServicesList[0]][0].price.currency
        : null
    }
  },
  hasBookedServices: state => Boolean(Object.keys(state.bookings).length)
}

export default getters